function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "mrdodohead-radial-gradient",
  cx: 356.33,
  cy: 48.51,
  r: 7.79,
  gradientTransform: "matrix(0.09, 1, -0.59, 0.05, 138.52, -285.6)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 0.26,
  stopColor: "#fdfdfd"
}), React.createElement("stop", {
  offset: 0.4,
  stopColor: "#f5f5f5"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#e7e7e7"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#d4d4d4"
}), React.createElement("stop", {
  offset: 0.68,
  stopColor: "#bbb"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#9c9c9c"
}), React.createElement("stop", {
  offset: 0.83,
  stopColor: "#787878"
}), React.createElement("stop", {
  offset: 0.9,
  stopColor: "#4d4d4d"
}), React.createElement("stop", {
  offset: 0.96,
  stopColor: "#1f1f1f"
}), React.createElement("stop", {
  offset: 1
})), React.createElement("radialGradient", {
  id: "mrdodohead-radial-gradient-2",
  cx: 318.04,
  cy: 48.51,
  r: 7.79,
  gradientTransform: "matrix(0.09, 1, -0.59, 0.05, 103.94, -243.33)",
  xlinkHref: "#mrdodohead-radial-gradient"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "shoe-right",
  d: "M127.48,302.48l.64,16.87H92.32s5.77-9.11,8.75-12.32,10.18-5.62,10.18-5.62Z",
  transform: "translate(-42.99 -4.88)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "shoe-left",
  d: "M157.09,300.82a57.34,57.34,0,0,1,9.36,5.06c5.45,3.55,8.73,13.18,8.73,13.18l-36.11.29,2.3-17.74Z",
  transform: "translate(-42.99 -4.88)"
});

var SvgMrdodohead = function SvgMrdodohead(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "MrDoDoHead",
    viewBox: "0 0 193.06 314.78",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "legs"
  }, React.createElement("path", {
    d: "M165.74,306.31a54.48,54.48,0,0,0-8.89-4.64l.8-62.42s3.18-1.91,6.73-4.18a4.4,4.4,0,0,1,1.38-.9,73.2,73.2,0,0,0,7.14-5.09c4.55-4,10.68-20.57,10.68-20.57l-12.45.5a5.2,5.2,0,0,1-1.68.26,5.35,5.35,0,0,1-1.24-.14,5,5,0,0,1-1.91.36,5.24,5.24,0,0,1-1.58-.23l-3.63.14a4.93,4.93,0,0,1-2.29.52,5.16,5.16,0,0,1-1.91-.35l-1.4.06a5.23,5.23,0,0,1-5,.19l-23.82,1a5.93,5.93,0,0,1-1.22.13,4.93,4.93,0,0,1-.78-.06l-32.27,1.28a8.51,8.51,0,0,1-1.16.19c-1.67.12-3.33.31-5,.33a5,5,0,0,1-1.4-.22l-4.85.19s1.5,10.6,7.65,17.47a4.38,4.38,0,0,1,1.16,1.19c.15.15.31.3.48.44.36.32.72.63,1.09.93a4.39,4.39,0,0,1,1.51,1.17,44.87,44.87,0,0,0,7.48,4.44,4.33,4.33,0,0,1,1.21.56c.93.41,1.82.77,2.66,1.09a4.63,4.63,0,0,1,.56.21,45.46,45.46,0,0,0,6.61,1.93l1.06,59.69S104.79,304,102,307s-8.16,11.48-8.16,11.48h33.37l-.6-15.72.22-27.45a4.07,4.07,0,0,1-.26-1.61c.24-6.33.34-12.47.22-18.79a3.58,3.58,0,0,1,0-.67,31.49,31.49,0,0,1,0-3.89,3.82,3.82,0,0,1,.19-1.13,4.69,4.69,0,0,1,.07-1.4l0-3,2.58.14a4.48,4.48,0,0,1,1.14-.16,3.92,3.92,0,0,1,1.46.27l1.32,0a69.73,69.73,0,0,0,7-.73l1.33,58-2.19,16.25,34.29-.26S170.92,309.56,165.74,306.31Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M101.56,239.68h.12a4.59,4.59,0,0,1,3.66,1.61V210.73a4.78,4.78,0,0,1-2.79.82,5.35,5.35,0,0,1-1.54-.22,5.35,5.35,0,0,1-3.25-.35v27.07h.12A4.57,4.57,0,0,1,101.56,239.68Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M89.31,232.28a4.5,4.5,0,0,1,3.34,2.8,4.75,4.75,0,0,1,.79,1.24V211.78a6.9,6.9,0,0,1-2.18.53c-1.67.12-3.33.31-5,.33-.14,0-.26,0-.4,0v16.74A4.44,4.44,0,0,1,89.31,232.28Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M116.13,211.12a5,5,0,0,1-2.56-.66,4.8,4.8,0,0,1-2.87.88,6.26,6.26,0,0,1-.63,0V313.49h7.58V210.9A5.21,5.21,0,0,1,116.13,211.12Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M126.24,310.81c.28-4.1.5-8.17.81-12.25a4,4,0,0,1-.26-1.44c0-6.94-.13-13.87.71-20.76a3.61,3.61,0,0,1-.93-2.69c.24-6.33.34-12.47.22-18.79a3.58,3.58,0,0,1,0-.67,31.49,31.49,0,0,1,0-3.89,3.74,3.74,0,0,1,.17-1.07,3.83,3.83,0,0,1,3.83-4.45,4.46,4.46,0,0,1,.91.09V209.42a4.72,4.72,0,0,1-3.09,1.05,5,5,0,0,1-.88-.08,5,5,0,0,1-2.26.51,5.2,5.2,0,0,1-1.35-.17V312.65h2.44A3.68,3.68,0,0,1,126.24,310.81Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M156.09,209.16a4.66,4.66,0,0,1-3.26,1.2,5,5,0,0,1-2.36-.56V313.49h7.58V209.87A4.64,4.64,0,0,1,156.09,209.16Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M144.12,209.75l-.45-.09h-.24a5.36,5.36,0,0,1-2.94-.12,5.08,5.08,0,0,1-1.67.27,5.28,5.28,0,0,1-1.53-.22v34.85a4.11,4.11,0,0,1,4.09,5c-1.8,8-.58,17.59-.52,25.79s-.23,17,.66,25.16v0a3.92,3.92,0,0,1,.33,1.59,60.79,60.79,0,0,1-.69,10.08,3,3,0,0,1-.54,1.23h4.26V209.85A6.31,6.31,0,0,1,144.12,209.75Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M171.08,231.74h.15V209a5.23,5.23,0,0,1-1.78.3,6,6,0,0,1-1.23-.13,5.21,5.21,0,0,1-1.92.35,4.86,4.86,0,0,1-2.65-.72V236a4.45,4.45,0,0,1,3.41-2.14A4.57,4.57,0,0,1,171.08,231.74Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M183.58,208.51l-.82,0v2.1C183.28,209.33,183.58,208.51,183.58,208.51Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M164.38,235.07a4.4,4.4,0,0,1,1.38-.9,73.2,73.2,0,0,0,7.14-5.09,14.42,14.42,0,0,0,2.28-2.78V208.85l-4.05.16a5.2,5.2,0,0,1-1.68.26,5.35,5.35,0,0,1-1.24-.14,5,5,0,0,1-1.91.36,5.24,5.24,0,0,1-1.58-.23l-3.63.14a4.93,4.93,0,0,1-2.29.52,5.16,5.16,0,0,1-1.91-.35l-1.4.06a5.23,5.23,0,0,1-5,.19l-23.82,1a5.93,5.93,0,0,1-1.22.13,4.93,4.93,0,0,1-.78-.06l-32.27,1.28a8.51,8.51,0,0,1-1.16.19c-1.67.12-3.33.31-5,.33a5,5,0,0,1-1.4-.22l-4.85.19s1.5,10.6,7.65,17.47a4.38,4.38,0,0,1,1.16,1.19c.15.15.31.3.48.44.36.32.72.63,1.09.93a4.39,4.39,0,0,1,1.51,1.17,44.87,44.87,0,0,0,7.48,4.44,4.33,4.33,0,0,1,1.21.56c.93.41,1.82.77,2.66,1.09a4.63,4.63,0,0,1,.56.21,45.46,45.46,0,0,0,6.61,1.93l1.06,59.69S104.79,304,102,307s-8.16,11.48-8.16,11.48h33.37l-.6-15.72.22-27.45a4.07,4.07,0,0,1-.26-1.61c.24-6.33.34-12.47.22-18.79a3.58,3.58,0,0,1,0-.67,31.49,31.49,0,0,1,0-3.89,3.82,3.82,0,0,1,.19-1.13,4.69,4.69,0,0,1,.07-1.4l0-3,2.58.14a4.48,4.48,0,0,1,1.14-.16,3.92,3.92,0,0,1,1.46.27l1.32,0a69.73,69.73,0,0,0,7-.73l1.33,58-2.19,16.25,34.29-.26s-3.11-8.83-8.29-12.08a54.48,54.48,0,0,0-8.89-4.64l.8-62.42S160.83,237.34,164.38,235.07Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M182.76,210.65v-2.1l-7.58.3V226.3C178.18,221.8,181.31,214.3,182.76,210.65Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  })), React.createElement("path", {
    id: "PantsOutline",
    d: "M183.58,208.51s-6.13,16.54-10.68,20.57c-3.53,3.13-15.25,10.17-15.25,10.17l-.8,62.42a54.48,54.48,0,0,1,8.89,4.64c5.18,3.25,8.29,12.08,8.29,12.08l-34.29.26,2.19-16.25-1.33-58a69.73,69.73,0,0,1-7,.73c-2.19,0-6.5-.27-6.5-.27l-.46,57.91.6,15.72H93.84S99.21,310,102,307s9.48-5.24,9.48-5.24L110.42,242s-11.92-2.2-21.12-10.33c-7.54-6.66-9.29-19.1-9.29-19.1Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#4c1207",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _ref3, _ref4), React.createElement("g", {
    id: "arm-right"
  }, React.createElement("path", {
    id: "hand-right",
    d: "M63.74,199.56c-.52,3,3.6,13.94,3.87,14.76s3.84,4.62-1.53,5.49-7.24-2-7.57-2.8-1.2.06-1.2.06.61,5.88-2.5,9.07-7.41.73-9.69-.91-.61-7.5.28-8.65.41-5.78.76-10.2,6-9.31,6-9.31Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#72251c",
      stroke: "#4c1207",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  }), React.createElement("path", {
    d: "M99.9,146.41c-7.06-13-19.32-3.53-19.32-3.53l-13,10.44-13.35,13-7.76,31.31,20.13,4.61,4.5-26L82,169.46l5.57-3.38S107,159.42,99.9,146.41Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#329cfc"
    }
  })), React.createElement("g", {
    id: "arm-left"
  }, React.createElement("path", {
    id: "hand-left",
    d: "M216.22,106.75s4.86-.82,7.78-3.39,2.75-4.58,2.75-4.58L233.43,94s1.75-1.27,1.62-3a18.28,18.28,0,0,0-3.7-8.07c-1.64-1.93-3.31-2.16-5.84-2.69a5,5,0,0,0-4.66.9c-1.63,1.27-5.26,4.39-5.26,4.39s-2.35-4.11-5.47-3.35-4.28,3.8-3,7.29c0,0-1.86,4.32-1.58,7.53a9.48,9.48,0,0,0,1.44,4.7Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#72251c",
      stroke: "#4c1207",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  }), React.createElement("path", {
    d: "M204.2,98.84l-13.62,25.54-18.66,7.55-11.51,5.28s-9,3.29-7.86,13.22c1.5,12.72,15.29,8.72,15.29,8.72l15-7.9L206,136.52l13.56-29.21Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#329cfc"
    }
  })), React.createElement("g", {
    id: "torso"
  }, React.createElement("path", {
    d: "M183.58,203.59s-4.84-20.83-7.69-32a232.8,232.8,0,0,0-7.43-23c-1.28-4.27-11.67-20.86-11.67-20.86l.46-2.42s-8.07,7.24-29.94,9.85a71.61,71.61,0,0,1-32-3.69c-4.07-1.44-4.88.86-4.88.86l-2.72,7.24.28,22.09s-3.6,12.59-4.86,20.15S78.72,208,78.72,208l8.56,3.38S121.65,217.05,183.58,203.59Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polyline", {
    points: "38.86 201.36 74.06 223.73 93.41 207.1 112.13 222.66 140.6 200.6",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), React.createElement("path", {
    d: "M136.62,155.54a4.2,4.2,0,1,1-3.87-4.51A4.21,4.21,0,0,1,136.62,155.54Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M138,171.57a4.2,4.2,0,1,1-3.87-4.51A4.2,4.2,0,0,1,138,171.57Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M139.39,187.75a4.2,4.2,0,1,1-3.87-4.51A4.2,4.2,0,0,1,139.39,187.75Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M78.72,208l7.13-65.13C86.22,130,106,130,106,130l20,73.67A72.19,72.19,0,0,0,95.77,220c-11.57,10.67,3.1,19.29,3.1,19.29S73.3,234.15,78.72,208Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#329cfc"
    }
  }), React.createElement("path", {
    d: "M176.81,209.85c-8.39-8.78-27.38-7.82-27.38-7.82l.16-77.33s8.26,3.14,11.59,5.14,19.46,50.84,19.46,50.84,6.07,21.19,6.07,35.36c0,11.05-10.18,19.61-21.28,19.56,0,0,11.76-7.66,13.26-15.63S176.81,209.85,176.81,209.85Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#329cfc"
    }
  }), React.createElement("polygon", {
    points: "61.93 127.42 49.1 151.28 61.91 154.82 53.42 165.37 80.88 197.74 61.93 127.42",
    style: {
      fill: "#0d1a99"
    }
  }), React.createElement("polygon", {
    points: "108.54 124.32 125.08 145.28 115.44 150.84 126.31 158.91 107.86 196.33 108.54 124.32",
    style: {
      fill: "#0d1a99"
    }
  })), React.createElement("g", {
    id: "head"
  }, React.createElement("g", {
    id: "basehead"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M184.94,105.43c2.05,19.69-16.12,20.92-16.12,20.92l-40.28,4.4c-15.79,1.72-49.08,4.76-39.22,3,45.24-8.14,65.77-28.39,65.78-29.8s-.68-.17-.68-.17c-18.6,20.54-67,30.26-67,30.26-12.39-.33-19.66-3.51-21.27-12.69C63.19,104.52,81,101.66,81,101.66c40,1.43,50.3-18.68,50.67-19.8s-.74,0-.74,0c-13.41,19.56-40.92,18.92-46.45,19-6.35.11-10.34-7.64-8.21-17S90.58,71.53,90.58,71.53c21.52,4.11,31.82-14.45,32-15.05s-.52-.27-.52-.27c-8.93,15.18-27.52,17.54-31.87,14s-2.68-13.17-2.68-13.17c1-8,14.17-12,14.17-12,9.37,0,13.13-6.22,13.51-6.76s-.5-.56-.5-.56c-6.26,8-13.93,6.26-13.93,6.26-2.47-.64-3-3.43-2.89-5.71.23-4.58,5.62-12,5.83-15.21s-3.65-4.76-3.43-6.07,5,0,8.79,1.07,16.08,7.36,24.25,16.15-3.49,17.24-3.49,17.24S142.76,42.1,151,54.21a12.46,12.46,0,0,1,.74,13.56s11.62-1.64,16.6,8.51c0,0,5.23,12.93-13.07,26.45,0,0,0,1.49.65.86s8.69-10.12,15.44-10.23S184.34,99.7,184.94,105.43Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#72251c"
    }
  }), React.createElement("path", {
    d: "M184.94,105.43c2.05,19.69-16.12,20.92-16.12,20.92l-40.28,4.4c-15.79,1.72-49.08,4.76-39.22,3,45.24-8.14,65.77-28.39,65.78-29.8s-.68-.17-.68-.17c-18.6,20.54-67,30.26-67,30.26-12.39-.33-19.66-3.51-21.27-12.69C63.19,104.52,81,101.66,81,101.66c40,1.43,50.3-18.68,50.67-19.8s-.74,0-.74,0c-13.41,19.56-40.92,18.92-46.45,19-6.35.11-10.34-7.64-8.21-17S90.58,71.53,90.58,71.53c21.52,4.11,31.82-14.45,32-15.05s-.52-.27-.52-.27c-8.93,15.18-27.52,17.54-31.87,14s-2.68-13.17-2.68-13.17c1-8,14.17-12,14.17-12,9.37,0,13.13-6.22,13.51-6.76s-.5-.56-.5-.56c-6.26,8-13.93,6.26-13.93,6.26-2.47-.64-3-3.43-2.89-5.71.23-4.58,5.62-12,5.83-15.21s-3.65-4.76-3.43-6.07,5,0,8.79,1.07,16.08,7.36,24.25,16.15-3.49,17.24-3.49,17.24S142.76,42.1,151,54.21a12.46,12.46,0,0,1,.74,13.56s11.62-1.64,16.6,8.51c0,0,5.23,12.93-13.07,26.45,0,0,0,1.49.65.86s8.69-10.12,15.44-10.23S184.34,99.7,184.94,105.43Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#4c1207",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  })), React.createElement("g", null, React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, React.createElement("path", {
    d: "M184.94,105.43c2.05,19.69-16.12,20.92-16.12,20.92l-40.28,4.4c-15.79,1.72-49.08,4.76-39.22,3,45.24-8.14,65.77-28.39,65.78-29.8s-.68-.17-.68-.17c-18.6,20.54-67,30.26-67,30.26-12.39-.33-19.66-3.51-21.27-12.69C63.19,104.52,81,101.66,81,101.66c40,1.43,50.3-18.68,50.67-19.8s-.74,0-.74,0c-13.41,19.56-40.92,18.92-46.45,19-6.35.11-10.34-7.64-8.21-17S90.58,71.53,90.58,71.53c21.52,4.11,31.82-14.45,32-15.05s-.52-.27-.52-.27c-8.93,15.18-27.52,17.54-31.87,14s-2.68-13.17-2.68-13.17c1-8,14.17-12,14.17-12,9.37,0,13.13-6.22,13.51-6.76s-.5-.56-.5-.56c-6.26,8-13.93,6.26-13.93,6.26-2.47-.64-3-3.43-2.89-5.71.23-4.58,5.62-12,5.83-15.21s-3.65-4.76-3.43-6.07,5,0,8.79,1.07,16.08,7.36,24.25,16.15-3.49,17.24-3.49,17.24S142.76,42.1,151,54.21a12.46,12.46,0,0,1,.74,13.56s11.62-1.64,16.6,8.51c0,0,5.23,12.93-13.07,26.45,0,0,0,1.49.65.86s8.69-10.12,15.44-10.23S184.34,99.7,184.94,105.43Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#93480e"
    }
  }), React.createElement("path", {
    d: "M184.94,105.43c2.05,19.69-16.12,20.92-16.12,20.92l-40.28,4.4c-15.79,1.72-49.08,4.76-39.22,3,45.24-8.14,65.77-28.39,65.78-29.8s-.68-.17-.68-.17c-18.6,20.54-67,30.26-67,30.26-12.39-.33-19.66-3.51-21.27-12.69C63.19,104.52,81,101.66,81,101.66c40,1.43,50.3-18.68,50.67-19.8s-.74,0-.74,0c-13.41,19.56-40.92,18.92-46.45,19-6.35.11-10.34-7.64-8.21-17S90.58,71.53,90.58,71.53c21.52,4.11,31.82-14.45,32-15.05s-.52-.27-.52-.27c-8.93,15.18-27.52,17.54-31.87,14s-2.68-13.17-2.68-13.17c1-8,14.17-12,14.17-12,9.37,0,13.13-6.22,13.51-6.76s-.5-.56-.5-.56c-6.26,8-13.93,6.26-13.93,6.26-2.47-.64-3-3.43-2.89-5.71.23-4.58,5.62-12,5.83-15.21s-3.65-4.76-3.43-6.07,5,0,8.79,1.07,16.08,7.36,24.25,16.15-3.49,17.24-3.49,17.24S142.76,42.1,151,54.21a12.46,12.46,0,0,1,.74,13.56s11.62-1.64,16.6,8.51c0,0,5.23,12.93-13.07,26.45,0,0,0,1.49.65.86s8.69-10.12,15.44-10.23S184.34,99.7,184.94,105.43Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#93480e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  })))), React.createElement("path", {
    d: "M184.94,105.43c2.05,19.69-16.12,20.92-16.12,20.92l-40.28,4.4c-15.79,1.72-49.08,4.76-39.22,3,45.24-8.14,65.77-28.39,65.78-29.8s-.68-.17-.68-.17c-18.6,20.54-67,30.26-67,30.26-12.39-.33-19.66-3.51-21.27-12.69C63.19,104.52,81,101.66,81,101.66c40,1.43,50.3-18.68,50.67-19.8s-.74,0-.74,0c-13.41,19.56-40.92,18.92-46.45,19-6.35.11-10.34-7.64-8.21-17S90.58,71.53,90.58,71.53c21.52,4.11,31.82-14.45,32-15.05s-.52-.27-.52-.27c-8.93,15.18-27.52,17.54-31.87,14s-2.68-13.17-2.68-13.17c1-8,14.17-12,14.17-12,9.37,0,13.13-6.22,13.51-6.76s-.5-.56-.5-.56c-6.26,8-13.93,6.26-13.93,6.26-2.47-.64-3-3.43-2.89-5.71.23-4.58,5.62-12,5.83-15.21s-3.65-4.76-3.43-6.07,5,0,8.79,1.07,16.08,7.36,24.25,16.15-3.49,17.24-3.49,17.24S142.76,42.1,151,54.21a12.46,12.46,0,0,1,.74,13.56s11.62-1.64,16.6,8.51c0,0,5.23,12.93-13.07,26.45,0,0,0,1.49.65.86s8.69-10.12,15.44-10.23S184.34,99.7,184.94,105.43Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#4c1207",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  })), React.createElement("g", {
    id: "eye-left"
  }, React.createElement("path", {
    d: "M155,76.19c1.06,9.74-4.16,18.3-11.65,19.12s-14.42-6.43-15.47-16.17S132,60.83,139.5,60,153.92,66.44,155,76.19Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M149.33,77.49c.67,6.17-2.23,11.55-6.48,12s-8.25-4.17-8.92-10.35,2.23-11.56,6.48-12S148.66,71.31,149.33,77.49Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "url(#mrdodohead-radial-gradient)"
    }
  })), React.createElement("g", {
    id: "eye-right"
  }, React.createElement("path", {
    d: "M116.91,80.32c1.06,9.75-4.15,18.31-11.64,19.12S90.85,93,89.79,83.27,93.94,65,101.43,64.15,115.85,70.58,116.91,80.32Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M111.26,81.62c.68,6.18-2.23,11.56-6.48,12s-8.24-4.18-8.92-10.35,2.24-11.56,6.49-12S110.59,75.45,111.26,81.62Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "url(#mrdodohead-radial-gradient-2)"
    }
  })), React.createElement("path", {
    id: "mouth",
    d: "M114.81,115.12s5.83,5.94,13,5.16,9.55-10.53,9.55-10.53Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    id: "eyebrow-right",
    d: "M97,61.26s1.31-3.88,4.21-4.19,4.48,3.11,4.48,3.11",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  }), React.createElement("path", {
    id: "eyebrow-left",
    d: "M134.05,57.23s1.31-3.87,4.21-4.19,4.48,3.12,4.48,3.12",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97208px"
    }
  })), React.createElement("g", {
    id: "bowtie"
  }, React.createElement("path", {
    d: "M109.89,150.75a3.94,3.94,0,0,1-4.36-3.5L104,133.46a3.94,3.94,0,0,1,3.5-4.35l18.39,5.2.65,6Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), React.createElement("path", {
    d: "M148.92,146.51a4,4,0,0,0,3.5-4.36l-1.5-13.79a4,4,0,0,0-4.36-3.5l-16.83,9,.64,6Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), React.createElement("path", {
    d: "M135.71,136.52a7.75,7.75,0,1,1-8.54-6.87A7.74,7.74,0,0,1,135.71,136.52Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), React.createElement("g", {
    id: "hat"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M140.59,32.78c-.51,2-8.28,1.85-17.37-.41s-16-5.72-15.54-7.75,8.28-1.85,17.37.4S141.09,30.75,140.59,32.78Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M138.9,12.85l-.09,0a.22.22,0,0,0,.05-.11c.48-1.9-3.86-4.6-9.68-6.05s-10.92-1.07-11.39.82a.57.57,0,0,0,0,.13h0L113.93,23h0l0,.11c-.48,1.9,3.86,4.61,9.68,6.05s10.92,1.08,11.4-.82v-.12l.09,0Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#fff"
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M122,5.6c-2.35.08-4,.65-4.22,1.68a.57.57,0,0,0,0,.13h0l-3.83,15.44h0l0,.11c-.26,1,.9,2.29,2.93,3.46Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M138.81,12.62a.22.22,0,0,0,.05-.11c.24-1-.77-2.14-2.59-3.26l-5.13,20.61c2.14-.13,3.59-.7,3.84-1.67v-.12l.09,0,3.83-15.44Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("path", {
    d: "M126.48,29.59,132,7.31c-.9-.31-1.85-.6-2.85-.85-.79-.19-1.55-.35-2.3-.48l-5.57,22.38c.73.23,1.48.46,2.27.65C124.58,29.26,125.55,29.45,126.48,29.59Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#c60e2d"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M115.31,17.46a.54.54,0,0,1,0-.11h0Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#0d1a99"
    }
  }), React.createElement("path", {
    d: "M136.4,22.57s0,.08,0,.13c-.47,1.89-5.57,2.26-11.39.81s-10.15-4.14-9.69-6L114,22.86h0a1.17,1.17,0,0,0,0,.11c-.47,1.9,3.87,4.6,9.69,6.05s10.92,1.07,11.39-.82c0,0,0-.08,0-.13l.08,0",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#0d1a99"
    }
  }), React.createElement("path", {
    d: "M117.83,7.29h0Z",
    transform: "translate(-42.99 -4.88)",
    style: {
      fill: "#0d1a99"
    }
  }))), React.createElement("ellipse", {
    cx: 128.6,
    cy: 8.89,
    rx: 3.11,
    ry: 10.84,
    transform: "translate(45.63 126.56) rotate(-75.89)",
    style: {
      fill: "#fff"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMrdodohead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mrdodohead.019f5ab5.svg";
export { ForwardRef as ReactComponent };